import React from "react";
import { Input } from "./common/Input";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";

export const QuestionnaireInput = ({ def, onRespond, currentResponse }) => {
	const onChange = (e) => {
		const value = e.target.value;

		const response = {};
		response.id = def.id;
		response.value = value;

		onRespond(response);
	};

	const value = currentResponse ? currentResponse.value || "" : "";

	return (
		<>
			<QuestionnaireHeader def={def} />

			<div className={"w-full pb-3 xs:pb-6 px-6 text-black text-center"}>
				<Input
					id="input"
					value={value}
					onChange={onChange}
					placeholder={def.placeholder}
					multiline={def.multiline}
					minRows={def.minRows}
					maxRows={def.maxRows}
					required={def.required}
					inputType={def.inputType}
					fullWidth={true}
					classes={def.classes}
					autoFocus={def.autoFocus}
					color={def.color}
				/>
			</div>

			<QuestionnaireFooter def={def} />
		</>
	);
};
